import { render, staticRenderFns } from "./PermissionInitError.vue?vue&type=template&id=200d9c87&scoped=true"
import script from "./PermissionInitError.vue?vue&type=script&lang=js"
export * from "./PermissionInitError.vue?vue&type=script&lang=js"
import style0 from "./PermissionInitError.vue?vue&type=style&index=0&id=200d9c87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200d9c87",
  null
  
)

export default component.exports